import React from 'react'
import { useForm } from "react-hook-form";
import {useSelector, useDispatch} from 'react-redux'
import FormGroup from 'components/Form/FormGroup'
import { updateAccountInfo } from 'store/actions/userActions'
import * as Yup from 'yup'

function NetworkClassesCheckbox(props) {

    const dispatch = useDispatch()
    const isSaving = useSelector(state => state.user.saving)

    const { user } = props

    const { register, control, handleSubmit, setValue, getValues, formState, errors, watch } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            displayNetworkClasses: Yup.boolean(),
            hideFromNetwork: Yup.boolean()
        }),
        defaultValues: {
            displayNetworkClasses: (user.instructorProfile?.displayNetworkClasses === false || user.instructorProfile?.displayNetworkClasses) ? user.instructorProfile?.displayNetworkClasses : true,
            hideFromNetwork: user.instructorProfile?.hideFromNetwork ? true : false,
            // (user.instructorProfile?.hideFromNetwork === true || user.instructorProfile?.displayNetworkClasses) ? user.instructorProfile?.displayNetworkClasses : true,
        }
    });

    const { dirty } = formState;

    const onSubmit = (data) => {

        

        const dataUpdate = {
            instructorProfile: {
                ...user.instructorProfile,
                ...data
            }
        }

        console.log(dataUpdate)

        dispatch(updateAccountInfo(dataUpdate))

        // if (handleFormSubmission) {
        //     handleFormSubmission(data)
        // }
    }

    return (

        <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup
                fullSize
                type="checkbox"
                name="displayNetworkClasses"
                label="Show Classes from my Network"
                sublabel={(<a href="http://help.sutrapro.com" target="_blank">Learn more</a>)}
                placeholder="Display all classes that I co-host with another partner on my scheduler."
                register={register}
                disabled={isSaving}
                onClick={(cb) => {
                    console.log("checkbox: ", cb.target.checked)
                    onSubmit({
                        displayNetworkClasses: cb.target.checked
                    })
                }}
            />

            <FormGroup
                fullSize
                type="checkbox"
                name="hideFromNetwork"
                label="Remove me from the Sutra Network"
                // sublabel={(<a href="http://help.sutrapro.com" target="_blank">Learn more</a>)}
                placeholder="Hide my name from the Sutra Network. Partners will no longer to search or add you as a partner."
                register={register}
                disabled={isSaving}
                onClick={(cb) => {
                    console.log("checkbox: ", cb.target.checked)
                    onSubmit({
                        hideFromNetwork: cb.target.checked
                    })
                }}
            />
        </form>
    )

}

export default NetworkClassesCheckbox;